// Custom components
import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import DisplayOnlyField from './DisplayOnlyField';
import HistoryTooltip from './HistoryTooltip';

function InputField(props) {
  const {
    multiline,
    label,
    id,
    extra,
    type,
    placeholder,
    variant,
    state,
    disabled,
    name,
    register,
    error,
    required,
    value,
    defaultValue,
    displayValue,
    onChange,
    autoComplete,
    min,
    sx,
    color,
    dataCy,
    displayOnly,
    withHistory,
    history = [],
  } = props;

  const displayValueSafe = displayValue ?? value ?? defaultValue ?? '';
  if (displayOnly || disabled) {
    return (
      <div className="flex items-center gap-2 w-full">
        <div className="flex flex-col flex-1">
          <DisplayOnlyField label={label} value={displayValueSafe} error={error} dataCy={dataCy} />
        </div>
        <HistoryTooltip show={withHistory} history={history} />
      </div>
    );
  }

  return register ? (
    <div className="flex items-center gap-2 flex-1">
      <TextField
        label={label}
        sx={{
          '& .MuiInputLabel-root': { color: color ? color : '' },
          '& .MuiInputLabel-root.Mui-focused': { color: color ? color : 'green' },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: error ? 'red' : color ? color : '',
            },
            '&:hover fieldset': {
              borderColor: error ? 'red' : color ? color : 'green',
            },
            '&.Mui-focused fieldset': {
              borderColor: color ? color : 'green',
            },
          },
          '& .MuiInputBase-input': { color: color ? color : '' },
        }}
        readOnly={disabled}
        className="shadow-sm"
        fullWidth
        classes={extra}
        step="any"
        min={min}
        {...register(`${name}`)}
        disabled={disabled}
        type={type}
        id={id}
        value={value}
        name={name}
        multiline={multiline}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete == false ? 'new-password' : ''}
      />
      <HistoryTooltip show={withHistory} history={history} />
    </div>
  ) : (
    <div className="flex items-center gap-2 flex-1">
      <TextField
        sx={{
          '& .MuiInputLabel-root': { color: color ? color : '' },
          '& .MuiInputLabel-root.Mui-focused': { color: error ? 'red' : color ? color : 'green' },
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: color ? color : '',
            },
            '&:hover fieldset': {
              borderColor: error ? 'red' : color ? color : 'green',
            },
            '&.Mui-focused fieldset': {
              borderColor: error ? 'red' : color ? color : 'green',
            },
          },
          '& .MuiInputBase-input': { color: color ? color : '' },
        }}
        label={label}
        error={error ? true : false}
        fullWidth
        multiline={multiline}
        readOnly={disabled}
        type={type}
        id={id}
        value={value}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        className="shadow-sm"
      />
      <HistoryTooltip show={withHistory} history={history} />
    </div>
  );
}

InputField.propTypes = {
  withHistory: PropTypes.bool,
  cley: PropTypes.string,
  history: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any,
      date: PropTypes.string,
      changeReason: PropTypes.string,
    })
  ),
};

export default InputField;
